var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useSearchParams } from "react-router-dom";
import { useMemo, useState } from "react";
import { useSetUrlSearchParam } from "./SetUrlSearchParam";
export var useUrlQueryParams = function (keys) {
    var searchParams = useSearchParams()[0];
    var setSearchParams = useSetUrlSearchParam();
    var stateKeys = useState(keys);
    return [
        useMemo(function () {
            return keys.reduce(function (prev, key) {
                var _a;
                return __assign(__assign({}, prev), (_a = {}, _a[key] = searchParams.get(key) || "", _a));
            }, {});
        }, [searchParams]),
        function (params) {
            return setSearchParams(params);
        },
    ];
};
